<h1 class="page-title mb-5">مركز تسوية منازعات المستثمرين</h1>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <div class="investors-dispute-content" dir="rtl">
          <h3 class="fw-bold mb-4" style="color: #007bff">
            نبذة عن مركز تسوية منازعات المستثمرين بالهيئة العامة للاستثمار
            والمناطق الحرة
          </h3>

          <p class="lead text-muted mb-3" style="line-height: 1.8">
            استكمالاً لمنظومة الخدمات المقدمة من الهيئة العامة للاستثمار
            والمناطق الحرة لتحسين مناخ الاستثمار, تم إنشاء مركز تسوية منازعات
            المستثمرين في عام 2009 لتسوية المنازعات التي قد تنشأ بين المستثمرين
            عن طريق الوساطة.
          </p>
          <p class="lead text-muted mb-3" style="line-height: 1.8">
            وقد روعي عند وضع قواعد المركز الاستفادة من آخر ما انتهت إليه
            الممارسات الدولية والتشريعات المقارنة, وكذا توصيات لجنة الأمم
            المتحدة للقانون التجاري الدولي (الأونسيترال).
          </p>
          <p class="lead text-muted mb-3" style="line-height: 1.8">
            الوساطة هي إحدى الوسائل البديلة للتقاضي, وفيها يقوم شخص محايد (وسيط)
            بمساعدة أطراف النزاع في سعيهم للوصول إلى تسوية ودية وسريعة للنزاع
            القائم بينهم, وذلك توفيراً للوقت والمال والجهد, دون إخلال بحق
            الأطراف في اللجوء إلى القضاء.
          </p>
          <p class="lead text-muted mb-4" style="line-height: 1.8">
            فإن كانت الغاية من اللجوء إلى الوساطة هي ضمان الوصول لحل سريع نابع
            من أطراف النزاع يحقق مصالحهم وينأى بهم عن بلوغ مرحلة التقاضي بما
            تمثله من إجراءات معقدة وطويلة يصعب التنبؤ بنتيجتها, فإن الحاجة
            لتنظيم إجراءات الوساطة تظل دائما من الأولويات التي تكفل تحقيق
            التوازن بين حقوق أطرافها والتزاماتهم تحقيقاً للأهداف المرجوة منها,
            ومن هنا كان لزاماً علينا تنظيم إجراءات الوساطة والتزامات جميع
            المشاركين فيها بالقواعد الماثلة.
          </p>

          <h4 class="fw-bold text-success mb-3 text-end">
            فيديو تعريفي عن مركز تسوية منازعات المستثمرين
          </h4>

          <!-- Video Embed -->
          <div class="ratio ratio-16x9 mb-5">
            <iframe src="https://www.youtube.com/embed/gZxGWz7wemw" title="YouTube video player" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen></iframe>
          </div>

          <!-- Accordion/Collapse Section -->
          <!-- Custom Collapsible Section -->
          <div class="faq-container mb-5">
            <div class="faq-item">
              <div class="faq-header" (click)="toggle()">
                <div class="indicator" [class.expanded]="isExpanded">
                  <i class="fa-solid" [class.fa-minus]="isExpanded" [class.fa-plus]="!isExpanded"></i>
                </div>
                <div class="title">
                  تنظيم إجراءات الوساطة والتزامات جميع المشاركين فيها بالقواعد
                  الماثلة
                </div>
              </div>
              <div class="faq-content" *ngIf="isExpanded">
                <div class="d-flex flex-column gap-3 mt-3">
                  <a href="assets/جسور التفاوض.pdf" target="_blank"
                    class="d-flex align-items-center text-decoration-none">
                    <i class="fa-regular fa-file-pdf text-danger fs-3 ms-2"></i>
                    <span class="text-success fs-5">جسور التفاوض</span>
                  </a>
                  <a href="assets/القواعد الاجرائية للمركز.pdf" target="_blank"
                    class="d-flex align-items-center text-decoration-none">
                    <i class="fa-regular fa-file-pdf text-danger fs-3 ms-2"></i>
                    <span class="text-success fs-5">القواعد الاجرائية للمركز</span>
                  </a>
                  <a href="assets/كتيب تعريفى عن دور مركز تسوية منازعات المستثمرين2.pdf" target="_blank"
                    class="d-flex align-items-center text-decoration-none">
                    <i class="fa-regular fa-file-pdf text-danger fs-3 ms-2"></i>
                    <span class="text-success fs-5">كتيب تعريفى عن دور مركز تسوية منازعات المستثمرين</span>
                  </a>
                  <a href="assets/االوساطة فى المنازعات التجارية.pdf" target="_blank"
                    class="d-flex align-items-center text-decoration-none">
                    <i class="fa-regular fa-file-pdf text-danger fs-3 ms-2"></i>
                    <span class="text-success fs-5">الوساطة فى المنازعات التجارية</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <app-fix-how-we-can-help></app-fix-how-we-can-help>
      </div>
    </div>
  </div>
</div>